import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/rev': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M289.7 274.9c0 36.2-29.4 65.6-65.6 65.6-36.2 0-65.6-29.4-65.6-65.6 0-36.2 29.4-65.6 65.6-65.6h0c36.1 0 65.5 29.4 65.6 65.6zM429.2 269.8v210.2h-210.2v-0.1c-110.9-2.7-200.1-93.4-200.1-205 0-108.6 84.3-197.3 191-204.6v-38.3l108.8 62.8-108.8 62.8v-39.1c-80 7.2-143 74.5-143 156.4 0 86.6 70.5 157.1 157.1 157.1s157.1-70.5 157.1-157.1c0-47.2-32.2-106.2-71.8-131.8l45.4-26.2c39.8 32.9 73.1 101.4 74.3 153h0.1z'
      }
    ]
  }
})
